import { render, staticRenderFns } from "./AllNotesPopUp.vue?vue&type=template&id=390c97ff&lang=html"
import script from "./AllNotesPopUp.vue?vue&type=script&lang=js"
export * from "./AllNotesPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports